import { useState, useRef } from "react";
import useSupercluster from "use-supercluster";

import {
  cleanSelectedTags,
  cleanSelectedTypeId,
} from "./helper";
import {
  getParameters,
} from "./sharedUtils";
// mapUtils.js
import { useAppContext } from "./account-context";

const CLUSTER_MAX_ZOOM = 14;

export function useMixMap(initialViewport) {

  const { account, initedData = {}, currentGeo } = useAppContext();
  const clusterSettings = account.clusters || {};
  const clusterEnabled = clusterSettings && clusterSettings.cluster_enabled;
  // set default center
  const defaultCenter = { lat: 38.569224, lng: -121.939158 };
  const {
    default_lat,
    default_lng,
  } = account;

  if (!!default_lat && !!default_lng) {
    defaultCenter.lat = +default_lat;
    defaultCenter.lng = +default_lng;
  }
  if (currentGeo && currentGeo.lat && currentGeo.lng) {
    defaultCenter.lat = +currentGeo.lat;
    defaultCenter.lng = +currentGeo.lng;
  }
  if (!!initedData.mapCenterLat && !!initedData.mapCenterLng) {
    defaultCenter.lat = +initedData.mapCenterLat;
    defaultCenter.lng = +initedData.mapCenterLng;
  }

  const currentParams = getParameters();
  const containerRef = useRef();
  const contentRef = useRef();
  const mapViewRef = useRef();
  const mapRef = useRef();
  const [geocoder, setGeocoder] = useState(null);
  const [autoSuggestion, setAutoSuggestion] = useState(null);
  const [filters, setFilters] = useState({
    radius: +account.default_radius,
    unit: account.distance_unit,
    tags: cleanSelectedTags(account.tags, initedData.selectedTags),
    bounds: {},
    location_type_id: cleanSelectedTypeId(
      account.location_types,
      initedData.selectedType
    ),
    geo:
      currentGeo && currentGeo.lat
        ? { lat: currentGeo.lat, lng: currentGeo.lng }
        : {},
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openingFilters, setOpeningFilters] = useState(false);
  const [mapViewPort, setMapViewPort] = useState({
    zoom: 10,
    bounds: null,
  });
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [points, setPoints] = useState([]);

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds: mapViewPort.bounds
      ? [
          mapViewPort.bounds.nw_lng,
          mapViewPort.bounds.se_lat,
          mapViewPort.bounds.se_lng,
          mapViewPort.bounds.nw_lat,
        ]
      : null,
    zoom: mapViewPort.zoom,
    options: { radius: 75, maxZoom: CLUSTER_MAX_ZOOM },
  });

  return {
    clusterEnabled,
    clusterSettings,
    defaultCenter,
    currentParams,
    containerRef,
    contentRef,
    mapViewRef,
    mapRef,
    geocoder, setGeocoder,
    autoSuggestion, setAutoSuggestion,
    filters, setFilters,
    isLoading, setIsLoading,
    isCollapsed, setIsCollapsed,
    openingFilters, setOpeningFilters,
    mapViewPort, setMapViewPort,
    selectedLocation, setSelectedLocation,
    hoveredLocation, setHoveredLocation,
    points, setPoints,
    clusters, supercluster
  };
}